export enum TaskStatus {
  NEW = 'new',
  IN_PROGRESS = 'inprogress',
  COMPLETE = 'complete',
}
